import { gbp, priceSaving } from "@/lib/api";

// "Retailer-stated retail price £X" + "Save £Y · Z% less" — only when genuinely higher.
export const SavingLine = ({ price, retail, qty = 1, testId = "saving-line", className = "" }) => {
  const s = priceSaving(price, retail, qty);
  if (!s) return null;
  return (
    <div className={`text-xs leading-snug ${className}`} data-testid={testId}>
      <div className="text-slate-500">Retailer-stated retail price {gbp(s.retail)}</div>
      <div className="font-semibold text-[#E05915]">Save {gbp(s.saved)} · {s.pct}% less</div>
    </div>
  );
};
